/* Base Bundle - Scripts comuns a todas as páginas */
import './theme/scripts/header';
import './theme/scripts/crossOriginTrack';
import './theme/scripts/utmTracker';